/* eslint-disable camelcase */

export const LiveChatParamsMapper = {
  hydrate({ ...data }) {
    return {
      ...data,
    };
  },
};
